export function isPublicRoute(pathname?: string): boolean {
  const path =
    pathname ??
    (typeof window !== 'undefined' ? window.location.pathname : '');

  return /(?:^|\/)public(?:\/|$)/.test(path);
}

export function isAuthenticatedApiBlockedOnPublic(url: string): boolean {
  return isPublicRoute() && url.includes('/settings/');
}
